(() => {
CookieConsent.run({
    revision: 1,
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right",
            equalWeightButtons: false,
            flipButtons: false
        },
        preferencesModal: {
            layout: "box",
            position: "left",
            equalWeightButtons: true,
            flipButtons: false
        }
    },
    categories: {
        necessary: {
            readOnly: true // this category cannot be disabled
        },
        analytics: {},
        marketing: {}
    },
    onConsent: ({ cookie: cookie })=>{
        $eeca6d65ffe86aff$var$onConsentCallback();
    },
    onChange: ({ cookie: cookie, changedCategories: changedCategories, changedPreferences: changedPreferences })=>{
        $eeca6d65ffe86aff$var$onConsentCallback();
    },
    language: {
        default: 'en',
        autoDetect: "browser",
        translations: {
            en: {
                consentModal: {
                    title: '',
                    description: "We use cookies to personalise content and marketing, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners. By clicking \u201CAccept All\u201D, you agree to the use of cookies. Please click \u201Cmanage preferences\u201D to learn more or to change your preferences.",
                    closeIconLabel: "",
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: '',
                    showPreferencesBtn: 'Manage preferences',
                    footer: '<a href="/en/privacy-policy/">Privacy Policy </a><br /><a href="/en/terms-of-service/">Terms and conditions</a>'
                },
                preferencesModal: {
                    title: "Consent Preferences Center",
                    closeIconLabel: "Close modal",
                    acceptAllBtn: "Accept all",
                    acceptNecessaryBtn: "",
                    savePreferencesBtn: "Save preferences",
                    serviceCounterLabel: "Service|Services",
                    sections: [
                        {
                            title: "Cookie Usage",
                            description: "We respect your preferences regarding cookies. You can give your consent to the use of cookies by accepting them in the cookie banner. You can choose to reject cookies in our cookie banner, apart from strictly necessary ones that allow you to use some functionalities of our service."
                        },
                        {
                            title: 'Strictly Necessary cookies <span class="pm__badge">Always Enabled</span>',
                            description: `Strictly necessary cookies help make a website navigable by activating basic functions such as page navigation and access to secure website areas. Without these cookies, the website would not be able to work properly.`,
                            linkedCategory: 'necessary'
                        },
                        {
                            title: "Analytics Cookies",
                            description: `Analytics cookies help the website owner understand how visitors interact with the website by collecting and reporting information.
                            <ul>
                            <li>Google analytics</li>
                            <li>Hotjar</li>
                            </ul>
                            `,
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing Cookies",
                            description: `Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and interesting to the individual user and thus more valuable for publishers and third-party advertisers.
                            <ul>
                            <li>Google Tag manager</li>
                            <li>Google Ads</li>
                            <li>Facebook Marketing</li>
                            <li>LinkedIn Marketing</li>
                            </ul>
                            `,
                            linkedCategory: "marketing"
                        },
                        {
                            title: "More information",
                            description: 'For any query in relation to my policy on cookies and your choices, please <a href="/fi/yhteys/">contact us</a>.'
                        }
                    ]
                }
            }
        }
    },
    disablePageInteraction: false
});
/**
 * We could add other concensual data gathering triggers here as well.
 */ function $eeca6d65ffe86aff$var$onConsentCallback() {
    // Define dataLayer and the gtag function.
    // Due to the fact that we wont need to load gtag in localhost
    // we have added this also here to prevent compiling errors
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        dataLayer.push(arguments);
    }
    const preferences = CookieConsent.getUserPreferences();
    if (preferences.acceptedCategories.includes('analytics')) gtag('consent', 'update', {
        'analytics_storage': 'granted'
    });
    else gtag('consent', 'update', {
        'analytics_storage': 'denied'
    });
    if (preferences.acceptedCategories.includes('marketing')) {
        gtag('consent', 'update', {
            'ad_storage': 'granted'
        });
        gtag('consent', 'update', {
            'ad_user_data': 'granted'
        });
        gtag('consent', 'update', {
            'ad_personalization': 'granted'
        });
    } else {
        gtag('consent', 'update', {
            'ad_storage': 'denied'
        });
        gtag('consent', 'update', {
            'ad_user_data': 'denied'
        });
        gtag('consent', 'update', {
            'ad_personalization': 'denied'
        });
    }
}

})();
//# sourceMappingURL=cookie-consent.js.map
